import { projectVenueSlice } from '../project-venue.slice';

export const clearCurrentProjectVenue = projectVenueSlice.actions.clearCurrent;
